<cdk-virtual-scroll-viewport [itemSize]="10" class="scroll-viewport">
  <mat-card appearance="outlined" class="card-widget nopadLR marB16 mat-card nopadT">
    <mat-card-content class="mat-card-content">
      <ul class="listItemSingle">
        <li
          [style.height]="itemSize + 'px'"
          *cdkVirtualFor="let candidate of dataSource; let i = index; templateCacheSize: 0"
          [ngClass]="{ focusClass: selectedCandidate == candidate }"
          id="{{ 'candidateIndxId' + i }}"
        >
          <a matRipple href="javascript:void(0);" (click)="displayCandidate(candidate)">
            <div class="row">
              <div *ngIf="candidate.match; else elseBlock">
                <div class="col-2">
                  <span class="data-letters float-left marR16" id="candidateInitial-{{ i }}">{{
                    candidate.candidateName | initials
                  }}</span>
                </div>
                <div class="col-6 marT8">
                  <h5
                    name="candidateName"
                    class="h5Header GreyDarkest"
                    [ngClass]="{ focusClass: selectedCandidate === candidate }"
                    id="candidateName-{{ i }}"
                  >
                    <strong>{{ candidate.candidateName | titlecase }}</strong>
                  </h5>
                  <span
                    class="mainBodyTxt4 GreyLight blockInfo marT4"
                    [ngClass]="{ focusClass: selectedCandidate === candidate }"
                    >{{ candidate.candidateSkills }}</span
                  >
                </div>

                <div class="col-2 listRight marL8 marB8">
                  <app-semicircular-progressbar [match]="candidate.match"> </app-semicircular-progressbar>
                </div>
              </div>
              <ng-template #elseBlock>
                <div class="col-2">
                  <span class="data-letters float-left marR16">{{ candidate.candidateName | initials }}</span>
                </div>

                <div class="col-7 marT8 marL">
                  <h5
                    name="candidateName"
                    class="h5Header GreyDarkest"
                    [ngClass]="{ focusClass: selectedCandidate === candidate }"
                  >
                    <strong>{{ candidate.candidateName | titlecase }}</strong>
                  </h5>
                  <span
                    class="mainBodyTxt4 GreyLight blockInfo marT4 wrap"
                    [ngClass]="{ focusClass: selectedCandidate === candidate }"
                  >
                    {{ candidate.candidateSkills?.length > 0 ? getSkills(candidate) : 'NO SKILL FOUND' }}
                  </span>
                </div>
              </ng-template>
            </div>
          </a>
        </li>
      </ul>
    </mat-card-content>
  </mat-card>
</cdk-virtual-scroll-viewport>
